import {z} from 'zod';

import {BaseVehicleValidationSchema} from './BaseVehicleValidationSchema';

export const ServiceVehicleValidationSchema = BaseVehicleValidationSchema.extend({
  vehicleClassId: z.string().nullable().optional(),
});

export type ServiceVehicleValidationSchemaType = z.infer<typeof ServiceVehicleValidationSchema>;
